<template>
  <div class="Discuss">
      <div class="edit clear">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="欢迎分享，鼓励原创，无论是你的学习体验、想法、工作生 活经验，还是好书、好文章、好资源，都可发在这里。"
            maxlength="90"
            show-word-limit
            v-model="discussData">
            </el-input>
            <el-button type="primary" class="float-right" @click="open">发起讨论</el-button>
      </div>
      <!-- 文本填写区域 --> 

      <div class="comment-list">
          <ul>
              <li v-for="(item, index) in discussList" :key="index">
                    <div class="comment-head">
                        <div class="img">
                            <img v-lazy="item.customeratturl" :alt="item.customername">
                        </div>
                        <div class="title">
                            <p class="name">{{item.customername}}</p>
                            <p class="time">{{item.datetime}}</p>
                        </div>
                    </div>
                    <div class="comment-msg">
                        <p class="msg">{{item.content}}</p>
                    </div>
              </li>
            <p v-if="nextpage && discussList.length >= 10" class="next-page" @click="nextPage">下一页</p>
            <p v-if="loading" class="next-page">加载中...</p>
            <p v-if="noMore" class="next-page">没有更多了</p>
          </ul>
            
      </div>
      <!-- 评论列表区域 -->

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getCourseDiscuss, uploadCourseDiscussInfo, } from 'api/course'
import {uploadCourseJoinInfo} from 'api/api'
export default {
    name: 'Discuss',
    props: ['studyData'],
    data() {
        return {
            courseid: this.$route.query.courseid,
            discussData: '',    // 讨论
            discussList: [],    // 讨论列表
            userIsLogin: this.user().isLogin, // 登录状态
            getCourseDiscussApi: {courseid: this.$route.query.courseid, minmsgid: -1, pageSize: 10},
            loading: false,
            noMore: false,
            nextpage: true,
            minId:  0 // 获取最小id
        }
    },
    mounted() {
        this.getDiscussList(-1)
    },
    methods: {
        nextPage() {    // 下一页

            this.nextpage = false
            this.loading = true
            
            console.log('discussList', this.discussList)

            
            for (let list in this.discussList) {
                if (list == 0) {
                    this.minId = this.discussList[list].comid
                } else {
                    if (this.minId > this.discussList[list].comid) {
                        this.minId = this.discussList[list].comid
                    }
                }
            }
            
            // this.getCourseDiscussApi.minmsgid = this.minId
            this.getDiscussList(this.minId)
            

        },
        uploadCourseJoinInfo() {
            this.setLoading(true)
            uploadCourseJoinInfo({
                data: {courseid: this.$route.query.courseid},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000') {
                        this.$message.success('参与成功')
                        this.$router.go(0)
                    } else {
                        this.$message.error(data.msg)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        open() {    // 发布评论
            
            // 判断用户是否登陆
            if (this.userIsLogin === false) {
                this.$message.info('请登录')
                this.setLoginPop(true)
            } else {

                if (this.discussData.length == 0 ) {
                    this.$message.error('请输入讨论内容')
                    return
                }

                // console.log(this.studyData)
                console.log(895)
                if (this.studyData.isjoin == 0) {
                    // 判断课程是否购买 
                    this.$alert('你需要购买课程后才能发起讨论。', '温馨提示', {
                        confirmButtonText: '立即购买',
                        confirmButtonClass: 'gopay-btn',
                        customClass: 'el-message-box-pay'
                    }).then(() => {
                        // 付费课程前往购买
                        console.log(this.studyData)
                        if (this.studyData.feetype == 2) {
                            const {href} = this.$router.resolve({
                                // name: 'OrderIndex', query: {'cid': this.$route.query.courseid}
                                name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.courseid,'kmctype':7}
                            })
                            window.open(href,'_blank')
                        } else if (this.studyData.feetype == 1) {
                            // 免费课程调用参与接口
                            this.uploadCourseJoinInfo()
                        }
                    }).catch(() => {
                    });
                } else {

                    this.setLoading(true)
                    uploadCourseDiscussInfo({
                        data: {courseid:this.courseid, content: this.discussData},
                        success: data => {

                            if (data.code == '000') {
                                this.$message({
                                    type: 'success',
                                    message: '发起成功'
                                });

                                // 初始化
                                this.discussData =''

                                // 调用讨论列表
                                this.getDiscussList(-1)

                            } else {
                                this.$message.error(data.mag)
                            }
                        },
                        error: data => {
                            this.$message.error(data.mag)
                        }
                    })

                }
                
            }


            
        },
        getDiscussList(min) {
            this.getCourseDiscussApi.minmsgid = min

            // 获取讨论列表 
            this.setLoading(true)
            getCourseDiscuss({
                data: this.getCourseDiscussApi,
                success: data => {
                    this.setLoading(false)

                    // 长度不为0时则为翻页
                    if (min == -1) {
                        this.discussList = data.data.discussinfo
                    } else {
                        this.$nextTick(() => {
                            this.loading = false
                            if (data.data.discussinfo.length == 0 ) {
                                this.noMore = true
                            } else {
                                this.discussList = this.discussList.concat(data.data.discussinfo)
                                
                                if (data.data.discussinfo.length >= 10) {
                                    this.nextpage = true
                                } else {
                                    this.noMore = true
                                }
                            }
                        })
                    }
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }

            })
            
        },
        ...mapActions(['setLoading','setLoginPop']),
        ...mapGetters(['user'])
    },
    filters: {},
    watch: {
        // 登陆信息发生变化
        getIsLogin() {
            console.log('登录状态发生变化')
            this.userIsLogin = this.user().isLogin
        }
    },
    computed: {
        getIsLogin() {
            return this.user().isLogin
        },
    },
    components: {}
    
}
</script>

<style lang="scss" type="text/scss" scope> 
.gopay-btn {
    border-color: #FF4747 !important;
    background: #FF4747 !important;
}
.Discuss {
    padding: 0 20px;
    padding-bottom: 80px;
    
   
    .next-page {
        margin-top: 10px;
        color: #999;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
    }

    .edit {
        .el-button {
            padding: 0 12px;
            margin-top: 20px;
            min-height: 29px;
            height: 29px;
            line-height: 29px;
        }
    }

    .comment-list {
        margin-top: 12px;

        .comment-head {
            margin-top: 24px;
            overflow: hidden;
            .img {
                float: left;
                margin-right: 20px;
                img {
                    display: block;
                    width: 46px;
                    height: 46px;
                    border-radius: 50%;
                    background: #ccc;
                }
            }
            .title {
                float: left;
                width: calc(100% - 66px);
                .name {
                    margin-top: 3px;
                    font-size:14px;
                }
                .time {
                    margin-top: 10px;
                    font-size:14px;
                    color: #999;
                }
            }

        }
        .comment-msg {
            margin-top: 16px;
            padding-left: 66px;
            padding-bottom: 12px;
            border-bottom: solid 1px #E5E5E5;

            .msg {
                font-size: 14px;
                line-height: 20px;
                word-break: break-all;
                -ms-word-break: break-all;
            }
        }
    }

    
}
.el-message-box-pay {
    .el-message-box__headerbtn {
        .el-message-box__close {
            display: block;
        }
    }
    .el-message-box__header {
        background: #fff;
        padding-bottom: 0;
        padding-top: 25px;
        .el-message-box__title {
            color: #333333;
            text-align: left;
        }
        .el-message-box__headerbtn {
            top: 5px;
            right: 5px;
        }
    }
    .el-message-box__content {
        font-size: 14px;
        border-bottom: none;
        .el-message-box__message {
            p {
                line-height: 20px;
                padding: 0 2px;
            }
        }
    }
    .el-message-box__btns {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 20px;
        .el-button {
            color: #fff;
            font-size: 14px;
        }
    }
}
</style>